import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const STAFF = { manifest: '/manifest.json', title: 'SnowTrack™' };
const PORTAL = { manifest: '/portal-manifest.json', title: 'My Snow Service' };

/**
 * ManifestSwitcher - points the web app manifest at the customer portal's own
 * manifest while a /portal route is showing, and back at the staff manifest
 * everywhere else.
 *
 * index.html links one manifest with start_url "/". A customer who installed
 * the portal from Chrome on Android got an icon that opened "/", which is the
 * marketing page for anyone without a staff session, and the icon carried the
 * staff app's name. Chrome and Safari read the manifest link and the
 * apple-mobile-web-app-title meta from the live document at install time, so
 * swapping them on navigation is enough.
 *
 * Rendered once inside the router, beside ScrollToTop. Renders nothing.
 */
function ManifestSwitcher() {
  const { pathname } = useLocation();
  const isPortal = pathname === '/portal' || pathname.startsWith('/portal/');

  useEffect(() => {
    const target = isPortal ? PORTAL : STAFF;
    const href = `${process.env.PUBLIC_URL || ''}${target.manifest}`;
    const link = document.querySelector('link[rel="manifest"]');
    if (link && link.getAttribute('href') !== href) link.setAttribute('href', href);
    const title = document.querySelector('meta[name="apple-mobile-web-app-title"]');
    if (title && title.getAttribute('content') !== target.title) title.setAttribute('content', target.title);
  }, [isPortal]);

  return null;
}

export default ManifestSwitcher;
